import axios from 'axios'

export const getCities = () => {
  return axios.get('route/cities')
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getCountries = () => {
  return axios.get('route/countries')
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getOrigins = () => {
  return axios.get('route/origins')
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getCityByCountryCode = (countryCode) => {
  return axios.get(`route/origin/${countryCode}`)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getCityDestinationByCountryCode = (countryCode) => {
  return axios.get(`route/destination/${countryCode}`)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const searchCity = (data) => {
  return axios.get(`route/like/${data}`)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const searchCityAndPort = ({name, incoterm, type}) => {
  return axios.get(`route/city-port/${name}/${incoterm}/${type}`)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/city.api.js